var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    preserveAspectRatio: "none",
    viewBox: "0 0 375 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375 172L-0.851196 172L-0.851181 -2.34038e-06C-0.851181 -2.34038e-06 -7.8484 70.6689 74.1191 70.6689C126.229 70.6689 233.688 70.6689 305.06 70.6689C343.72 70.669 375 102.009 375 140.669L375 172Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomWave);
export default __webpack_public_path__ + "static/media/bottomWave.d33b83b3e3c07f3d904fcfc3a63831fc.svg";
export { ForwardRef as ReactComponent };